<div *ngIf="loading" class="text-center section-padding">Loading treatments...</div>
<div *ngIf="errorMessage" class="text-center section-padding text-danger">{{ errorMessage }}</div>

<section class="section-padding" [ngClass]="catIndex % 2 === 0 ? 'bg-blue-light' : 'bg-blue'"
    *ngFor="let group of categoryGroups; let catIndex = index">
    <div class="container">
        <div class="text-center">
            <h2 class="section-title"><span>{{ group.category }}</span></h2>
        </div>

        <!-- More than 3 treatments: use swiper with arrows -->
        <div class="swiper-wrapper-custom" *ngIf="group.treatments.length > 3">
            <button [class]="'custom-prev custom-prev-' + catIndex">
                <i class="fa fa-chevron-left"></i>
            </button>

            <swiper-container #swiper init="false" [attr.data-loop]="group.loop" [attr.data-index]="catIndex">
                <swiper-slide *ngFor="let t of group.treatments; trackBy: trackById">
                    <div class="treatment-card2">
                        <div class="card-glow"></div>
                        <div class="treatment-content">
                            <div class="treatment-icon">
                                <!-- <img [src]="imageBaseUrl + t.Image" (error)="setDefaultImage($event)" [alt]="t.TreatmentName + ' Icon'"> -->

                                <img *ngIf="t.Image && !t.imgFailed" [src]="imageBaseUrl + t.Image"
                                    [alt]="t.TreatmentName + ' Icon'" (error)="t.imgFailed = true">

                                <div class="treatment-icon-placeholder" *ngIf="!t.Image || t.imgFailed">
                                    <span>{{ t.TreatmentName }}</span>
                                </div>


                            </div>
                            <div class="treatment-info">
                                <h4 class="treatment-title">{{ t.TreatmentName }}</h4>
                                <p class="treatment-text">
                                    <span class="advantages">Advantages - </span>{{ t.Advantages }}
                                </p>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>

            <button [class]="'custom-next custom-next-' + catIndex">
                <i class="fa fa-chevron-right"></i>
            </button>
        </div>

        <!-- 3 or fewer treatments: plain centered cards, no swiper, no arrows -->
        <div class="static-treatments-wrapper" *ngIf="group.treatments.length <= 3">
            <div class="treatment-card2" *ngFor="let t of group.treatments; trackBy: trackById">
                <div class="card-glow"></div>
                <div class="treatment-content">
                    <div class="treatment-icon">
                        <!-- <img [src]="imageBaseUrl + t.Image" (error)="setDefaultImage($event)"
                            [alt]="t.TreatmentName + ' Icon'"> -->
                        <img *ngIf="t.Image && !t.imgFailed" [src]="imageBaseUrl + t.Image"
                            [alt]="t.TreatmentName + ' Icon'" (error)="t.imgFailed = true">

                        <div class="treatment-icon-placeholder" *ngIf="!t.Image || t.imgFailed">
                            <span>{{ t.TreatmentName }}</span>
                        </div>
                    </div>
                    <div class="treatment-info">
                        <h4 class="treatment-title">{{ t.TreatmentName }}</h4>
                        <p class="treatment-text">
                            <span class="advantages">Advantages - </span>{{ t.Advantages }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>